import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFreetierIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_876_17170)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M4 11C4 6.58172 7.58172 3 12 3H28C32.4183 3 36 6.58172 36 11V27C36 31.4183 32.4183 35 28 35H12C7.58172 35 4 31.4183 4 27V11Z",
				fill: "url(#paint0_linear_876_17170)"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M4 11C4 6.58172 7.58172 3 12 3H28C32.4183 3 36 6.58172 36 11V27C36 31.4183 32.4183 35 28 35H12C7.58172 35 4 31.4183 4 27V11Z",
				fill: "url(#paint1_radial_876_17170)",
				fillOpacity: .8
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_876_17170",
				x: 0,
				y: 0,
				width: 40,
				height: 40,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_876_17170"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_876_17170",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_876_17170",
				x1: 4,
				y1: 19,
				x2: 36,
				y2: 19,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#B4FFF6" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .5,
						stopColor: "#F7FFEB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#CDFFCB"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint1_radial_876_17170",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(20 3) rotate(63.4349) scale(35.7771 10.2189)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#A3D4FF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#A3D4FF",
					stopOpacity: 0
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgFreetierIcon);
export default ForwardRef;
